import type { Dictionary, Locale } from './types';
import en from './locales/en';
import es from './locales/es';

/**
 * Registry of all available dictionaries, keyed by locale code. Add a new
 * locale by creating `src/i18n/locales/<code>.ts` (copy `en.ts` as a
 * starting point) and registering it here — see `docs/I18N.md`.
 */
export const dictionaries: Record<Locale, Dictionary> = { en, es };
